import { Icon } from '@zapier/design-system';
import { useContext } from 'react';

import { Button, ComboBoxStateContext } from 'react-aria-components';

import { TypeaheadRootProps } from './Typeahead';
import styles from './TypeaheadRightSlot.module.scss';

type TypeaheadRightSlotProps = {
  isTypeaheadDisabled?: boolean;
  size: TypeaheadRootProps['size'];
};

/**
 * A component for a button to clear the `Typeahead` selection in the input,
 * as well as display an icon on the right side of the input if set.
 */
export const TypeaheadRightSlot = ({
  isTypeaheadDisabled = false,
  size,
}: TypeaheadRightSlotProps) => {
  const state = useContext(ComboBoxStateContext);
  const showClearSelectionButton = state?.inputValue && !isTypeaheadDisabled;

  const getIconSize = () => {
    if (size === 'compact') return '16px';
    if (size === 'large') return '24px';

    // Default to medium size icon.
    return '20px';
  };

  return showClearSelectionButton ? (
    <div className={styles.iconButtonWrapper} data-size={size} data-zds>
      {/* DS-3076 will replace this custom button with an DS IconButton component */}
      <Button
        aria-label="Clear selection"
        className={styles.clearButton}
        data-size={size}
        data-zds
        onPress={() => state?.setSelectedKey(null)}
        // Don't inherit default RAC Button behavior from RAC ComboBox.
        slot={null}
      >
        <Icon
          className={styles.icon}
          name="arrowRefresh"
          color="StrokeStronger"
          size={getIconSize()}
        />
      </Button>
    </div>
  ) : undefined;
};
